
import * as module0 from './controllers/about_controller.js';import * as module1 from './controllers/collection_controller.js';import * as module2 from './controllers/contacts_controller.js';import * as module3 from './controllers/flow_controller.js';import * as module4 from './controllers/header_mobile_controller.js';import * as module5 from './controllers/headline_controller.js';import * as module6 from './controllers/piece_controller.js';import * as module7 from './controllers/scrolling_controller.js';import * as module8 from './controllers/section_controller.js'
const modules = {
"./controllers/about_controller.js": module0,
"./controllers/collection_controller.js": module1,
"./controllers/contacts_controller.js": module2,
"./controllers/flow_controller.js": module3,
"./controllers/header_mobile_controller.js": module4,
"./controllers/headline_controller.js": module5,
"./controllers/piece_controller.js": module6,
"./controllers/scrolling_controller.js": module7,
"./controllers/section_controller.js": module8,
};
export default modules;
